import { Breadcrumb } from '../../../../components/Breadcrumb';
import { SettingsMenu, type SettingsMenuEntry } from '../../../../components/settings/SettingsMenu';

/*
  What Survey configures. One row per surface, each leading to its own page — see
  `<SettingsMenu>` for why the lists are not inlined here.

  **Empty today, and it says so** rather than promising settings the module does not have.
  Every catalog this module grows belongs on this page, never as a sidebar row of its own,
  which is what keeps the rail at one entry per module. A row carries the key of the surface
  behind it; when one arrives, add that key to the route's `anyOf` and the sidebar entry's
  `anyPermission` in the same change.
*/
const ENTRIES: SettingsMenuEntry[] = [];

/**
 * Learning & Development → Settings: a **menu of what Survey configures**, not the settings
 * themselves. Each row leads to a full page.
 */
export function SurveySettingsPage() {
  return (
    <div className="flex h-full min-h-0 min-w-0 flex-col bg-slate-50">
      <Breadcrumb segments={['Learning & Development', 'Settings']} />

      <div className="modern-scrollbar min-h-0 flex-1 overflow-auto p-4">
        <div className="mx-auto flex max-w-3xl flex-col gap-3">
          <p className="text-xs text-slate-500">
            The vocabularies a survey draws on. The surveys themselves are on the Survey page.
          </p>

          <SettingsMenu entries={ENTRIES} emptyMessage="Survey has nothing to configure yet." />
        </div>
      </div>
    </div>
  );
}
